// @flow strict

import * as React from 'react';
import cx from 'classnames';
import FormattedContent from '../../../internal/FormattedContent';
import logo from '../../../static/images/ansarada_logo.png';
import styles from './styles.scss';

type PropTypes = {|
  title: string,
  message: string,
  bgMobile: string,
  bgDesktop: string,
  imageFirst?: boolean,
|};

const ThankYou = ({ title, message, bgDesktop, bgMobile, imageFirst = false }: PropTypes) => {
  const hasBg = bgDesktop || bgMobile;

  return (
    <div className={cx(styles.page, imageFirst && styles.imageFirst)}>
      <div className={styles.header}>
        <a href="/">
          <img className={styles.logo} src={logo} alt="Ansarada" width="176" height="23" />
        </a>
      </div>
      <div className={styles.main}>
        <h2 className={styles.title}>{title}</h2>
        <div className={cx(styles.content)}>
          <FormattedContent>{message}</FormattedContent>
        </div>
      </div>
      {hasBg && (
        <div className={styles.layoutContainer}>
          <div className={styles.stepContainer}>
            <div />
          </div>
          <div className={styles.imageWrapper}>
            {bgDesktop && <img src={bgDesktop} alt="" className={styles.bgDesktopImage} />}
            {bgMobile && <img src={bgMobile} alt="" className={styles.bgMobileImage} />}
          </div>
        </div>
      )}
    </div>
  );
};

export default ThankYou;
